export default __webpack_public_path__ + "static/zameen-819fd0ee1de7a5f09548fa53f90ee78b.png";